import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container" style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 16 }}>
        <div>
          <strong style={{ color: '#fff' }}>The USA Rules Magazine</strong>
          <p style={{ maxWidth: 420 }}>
            An automated aggregator of headlines from top U.S. publications. Every story links back to its
            original source — we do not republish full articles.
          </p>
        </div>
        <div>
          <div><Link to="/about">About Us</Link></div>
          <div><Link to="/dmca">DMCA / Copyright takedown</Link></div>
          <div><a href="/legal/dmca-policy.md">DMCA Policy</a></div>
          <div><a href="/legal/privacy-policy.md">Privacy Policy</a></div>
          <div><a href="/legal/terms-of-service.md">Terms of Service</a></div>
          <div>DMCA Agent: dmca@usarulesmagazine.com</div>
        </div>
      </div>
    </footer>
  );
}
